<template>
  <div>
    <div v-for="(timeWindowItem, index) in reportTimeWindow" :key="index">
      <b-row class="text-muted mc-report-view__label-info">
        <b-col sm="2">Jenis Laporan</b-col>
        <b-col sm="2">Periode Laporan</b-col>
        <b-col sm="1">Kendaraan</b-col>
        <b-col sm="1">Garasi</b-col>
        <b-col sm="2">Keluar Garasi</b-col>
        <b-col sm="2">Masuk Garasi</b-col>
        <b-col sm="2">Durasi Siklus</b-col>
      </b-row>
      <b-row class="mc-report-view__text-info">
        <b-col sm="2">
          <span>Jendela Waktu</span>
        </b-col>
        <b-col>
          <span
            >{{ momentDateShortMonth(periode[0]) }} -
            {{ momentDateShortMonth(periode[1]) }}</span
          >
        </b-col>
        <b-col sm="1"
          ><span>{{ filterVehicle.licensePlate }}</span></b-col
        >
        <b-col sm="1"
          ><span>{{
            filterGeofence.garage ? filterGeofence.garage : filterGeofence
          }}</span></b-col
        >
        <b-col sm="2"
          ><span v-if="timeWindowItem.out"
            >{{ momentDateShortMonth(timeWindowItem.out) }}
            {{ momentTimeSeconds(timeWindowItem.out) }}</span
          ><span v-else>-</span></b-col
        >
        <b-col sm="2"
          ><span v-if="timeWindowItem.in"
            >{{ momentDateShortMonth(timeWindowItem.in) }}
            {{ momentTimeSeconds(timeWindowItem.in) }}</span
          ><span v-else>-</span></b-col
        >
        <b-col sm="2"
          ><span>{{
            timeWindowItem.time ? timeWindowItem.time : "-"
          }}</span></b-col
        >
      </b-row>
      <b-card class="mt-3">
        <div class="mc-report-view__table">
          <div class="row">
            <!-- Search -->
            <div class="col-md-12">
              <div class="mc-table-view">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end float-end"
                >
                  <label
                    class="d-inline-flex align-items-center mc-table-view__search"
                  >
                    <i class="mc-fa fas fa-search"></i>
                    <b-form-input
                      v-model="filter[index]"
                      type="search"
                      :placeholder="$t('global.search') + '...'"
                      class="ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <!-- End search -->
          </div>

          <div class="table-responsive my-3 border border-1">
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-card>
                  <b-skeleton-table
                    :rows="3"
                    :columns="fields.length"
                    :table-props="{ bordered: false, striped: true }"
                  >
                  </b-skeleton-table>
                </b-card>
              </template>
              <b-table
                class="datatables"
                :items="timeWindowItem.data"
                :fields="fields"
                responsive="xl"
                show-empty
                :empty-text="$t('global.emptyTable')"
                :per-page="perPage[index]"
                :current-page="currentPage[index]"
                :empty-filtered-text="$t('global.emptyFilteredTable')"
                :filter="filter[index]"
                :filter-included-fields="filterOn"
                @filtered="onFiltered($event, index)"
                filter-debounce="500"
              >
                <template #cell(fenceName)="data">
                  <template v-if="data.item.geofence.fenceName">
                    {{
                      data.item.geofence.fenceName
                        ? data.item.geofence.fenceName
                        : "-"
                    }}<br />
                  </template>
                  <span v-else>-</span>
                </template>

                <template #cell(transitOn)="data">
                  <template v-if="data.item.transitOn">
                    {{
                      data.item.transitOn
                        ? momentDateShortMonth(data.item.transitOn)
                        : "-"
                    }}<br />
                    <span class="text-muted">{{
                      data.item.transitOn
                        ? momentTimeSeconds(data.item.transitOn)
                        : "-"
                    }}</span>
                  </template>
                  <span v-else>-</span>
                </template>

                <template #cell(doorOpen)="data">
                  <template v-if="data.item.doorOpen">
                    {{
                      data.item.doorOpen
                        ? momentDateShortMonth(data.item.doorOpen)
                        : "-"
                    }}<br />
                    <span class="text-muted">{{
                      data.item.doorOpen
                        ? momentTimeSeconds(data.item.doorOpen)
                        : "-"
                    }}</span>
                  </template>
                  <span v-else>-</span>
                </template>

                <template #cell(doorClose)="data">
                  <template v-if="data.item.doorClose">
                    {{
                      data.item.doorClose
                        ? momentDateShortMonth(data.item.doorClose)
                        : "-"
                    }}<br />
                    <span class="text-muted">{{
                      data.item.doorClose
                        ? momentTimeSeconds(data.item.doorClose)
                        : "-"
                    }}</span>
                  </template>
                  <span v-else>-</span>
                </template>

                <template #cell(transitOnOut)="data">
                  <template v-if="data.item.transitOnOut">
                    {{
                      data.item.transitOnOut
                        ? momentDateShortMonth(data.item.transitOnOut)
                        : "-"
                    }}<br />
                    <span class="text-muted">{{
                      data.item.transitOnOut
                        ? momentTimeSeconds(data.item.transitOnOut)
                        : "-"
                    }}</span>
                  </template>
                  <span v-else>-</span>
                </template>

                <template #cell(timeInQueue)="data">
                  <template>
                    {{ data.item.timeInQueue ? data.item.timeInQueue : "-" }}
                  </template>
                </template>

                <template #cell(timeLoading)="data">
                  <template>
                    {{
                      data.item.timeLoading
                        ? data.item.timeLoading
                        : "-"
                    }}
                  </template>
                </template>

                <template #cell(timeOutQueue)="data">
                  <template>
                    {{ data.item.timeOutQueue ? data.item.timeOutQueue : "-" }}
                  </template>
                </template>

                <template #cell(timeInGeofence)="data">
                  <template>
                    {{
                      data.item.timeInGeofence ? data.item.timeInGeofence : "-"
                    }}
                  </template>
                </template>

                <template #cell(timeBetweenGeofence)="data">
                  <template>
                    {{
                      data.item.timeBetweenGeofence
                        ? data.item.timeBetweenGeofence
                        : "-"
                    }}
                  </template>
                </template>

                <template slot="bottom-row" v-if="filteredItems[index].length > 0">
                  <b-td colspan="5">
                    <template> Rata-Rata </template>
                  </b-td>
                  <b-td v-for="field in footerArr" :key="field.key">
                    <template>
                      {{
                        convertToTime(
                          totalFooter[index][field] / filteredItems[index].length
                        )
                      }}
                    </template>
                  </b-td>
                </template>
              </b-table>
            </b-skeleton-wrapper>
          </div>
          <div class="row mt-3" v-if="loaded">
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Menampilkan
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage[index]"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                  entri. <p>Menampilkan <strong>{{
                    filteredItems[index].length > 0
                      ? (currentPage[index] - 1) * perPage[index] + 1
                      : 0
                  }}</strong
                  > - <strong>{{
                    Math.min(filteredItems[index].length, currentPage[index] * perPage[index])
                  }}</strong
                  > dari <strong>{{ filteredItems[index].length }}</strong
                  ></p>
                </label>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage[index]"
                    :total-rows="
                      filteredItems[index] == null
                        ? filteredItems[index].length
                        : filteredItems[index].length
                    "
                    :per-page="perPage[index]"
                  >
                  </b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div v-if="currentPage.length === 0 && fields.length > 0">
      <b-row class="text-muted mc-report-view__label-info">
        <b-col sm="2">Jenis Laporan</b-col>
        <b-col sm="2">Periode Laporan</b-col>
        <b-col sm="1">Kendaraan</b-col>
        <b-col sm="1">Garasi</b-col>
        <b-col sm="2">Keluar Garasi</b-col>
        <b-col sm="2">Masuk Garasi</b-col>
        <b-col sm="2">Durasi Siklus</b-col>
      </b-row>
      <b-row class="mc-report-view__text-info">
        <b-col md="2">
          <span>Jendela Waktu</span>
        </b-col>
        <b-col md="2">
          <span>{{ momentDateShortMonth(periode[0]) }} - {{
              momentDateShortMonth(periode[1])
            }}</span>
        </b-col>
        <b-col sm="1"><span>{{ filterVehicle.licensePlate }}</span></b-col>
        <b-col sm="1"><span>{{ filterGeofence.garage }}</span></b-col>
        <b-col sm="2"><span>-</span></b-col>
        <b-col sm="2"><span>-</span></b-col>
        <b-col sm="2"><span>-</span></b-col>
      </b-row>

      <b-card class="mt-3">
        <div class="mc-report-view__table">
          <div class="row">
            <!-- Search -->
            <div class="col-md-12">
              <div class="mc-table-view">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end float-end"
                >
                  <label
                    class="d-inline-flex align-items-center mc-table-view__search"
                  >
                    <i class="mc-fa fas fa-search"></i>
                    <b-form-input
                      type="search"
                      :placeholder="$t('global.search') + '...'"
                      class="ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <!-- End search -->
          </div>

          <div class="table-responsive my-3 border border-1">
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-card>
                  <b-skeleton-table
                    :rows="3"
                    :columns="fields.length"
                    :table-props="{ bordered: false, striped: true }"
                  >
                  </b-skeleton-table>
                </b-card>
              </template>
              <b-table
                class="datatables"
                responsive="xl"
                show-empty
                :items="reportTimeWindow"
                :fields="fields"
                :empty-text="$t('global.emptyTable')"
                :per-page="todoperPage"
                :empty-filtered-text="$t('global.emptyFilteredTable')"
                :filter-included-fields="filterOn"
              >
              </b-table>
            </b-skeleton-wrapper>
          </div>
          <div class="row mt-3">
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Menampilkan
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="todoperPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                  entri.
                  <p>Menampilkan <strong>0</strong> - <strong
                    >0 </strong
                  > dari <strong>0</strong></p>
                </label>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    :total-rows="1 == null ? 1 : 1"
                    :per-page="todoperPage"
                  >
                  </b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { Helper } from "@/mixin/helper";
import { Export } from "@/mixin/export";
import { GET_REPORT_TIME_WINDOW } from "@/services/api/report/report";
import { EXPORT_PDF_REPORT_TIME_WINDOW } from "@/services/api/report/pdf";
import { EXPORT_EXCEL_REPORT_TIME_WINDOW } from "@/services/api/report/excel";

moment.locale("id");

export default {
  name: "TimeWindow",
  mixins: [Helper, Export],
  data() {
    return {
      tableData: [],
      totalRows: [],
      todoTotalRows: 1,
      currentPage: [],
      todocurrentPage: 1,
      perPage: [],
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: [],
      filterVehicle: [],
      filterGeofence: [],
      filterOn: [],
      reportTimeWindow: [],
      fields: [],
      isLoading: false,
      fileName: "",
      openSection: false,
      periode: [],
      filteredItems: [],
      totalFooter: [],
      timer: null,
      loaded: true,
      footerArr: [
        "timeInQueue",
        "timeLoading",
        "timeOutQueue",
        "timeInGeofence",
        "timeBetweenGeofence",
      ],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.reportTimeWindow.length;
    },

    /**
     * Todo list of records
     */
    listData() {
      return this.reportTimeWindow;
    },
  },
  methods: {
    /**
     * Search the table data with search input
     */

    initResult(data) {
      var res = [];
      var self = this;
      if (data.length === 0) {
        this.currentPage = [];
        this.perPage = [];
      }
      data.forEach(function (item, index) {
        self.currentPage[index] = 1;
        self.perPage[index] = 10;
        self.filteredItems[index] = item.data;

        if (self.totalFooter[index] === undefined) {
          self.totalFooter[index] = {
            timeInQueue: 0,
            timeLoading: 0,
            timeOutQueue: 0,
            timeInGeofence: 0,
            timeBetweenGeofence: 0,
          };
        }

        item.data.forEach(function (res) {
          self.totalFooter[index].timeInQueue += self.convertToSeconds(
            res.timeInQueue
          );
          self.totalFooter[index].timeLoading += self.convertToSeconds(
            res.timeLoading
          );
          self.totalFooter[index].timeOutQueue += self.convertToSeconds(
            res.timeOutQueue
          );
          self.totalFooter[index].timeInGeofence += self.convertToSeconds(
            res.timeInGeofence
          );
          self.totalFooter[index].timeBetweenGeofence += self.convertToSeconds(
            res.timeBetweenGeofence
          );
        });
      });
      return res;
    },
    onFiltered(item, index) {
      this.loaded = !this.loaded;
      this.filteredItems[index] = item;
      this.currentPage[index] = 1;
      this.perPage[index] = 10;

      this.$nextTick(() => {
        this.loaded = !this.loaded;
      });
    },
    refreshData(periode, filterVehicle, filterGeofence, fields) {
      this.fields = fields.filter(
        (field) => field.key !== "vehicle" && field.key !== "geofence"
      );
      this.isLoading = true;
      this.periode = periode;
      this.filterGeofence = filterGeofence;
      this.filterVehicle = filterVehicle;

      var filters = {};
      if (filterVehicle !== undefined) {
        filters = {
          vehicleId: filterVehicle.vehicleId,
        };
      }

      var filterGeofences = {};
      if (filterGeofence !== undefined) {
        filterGeofences = {
          geofenceId: filterGeofence.geofenceId,
        };
      }

      var filterVar = {
        startDate: moment(periode[0] + " 00:00:00.000").toISOString(),
        endDate: moment(periode[1] + " 23:59:59.000").toISOString(),
        ...filters,
        ...filterGeofences,
      };

      var self = this;
      var getData = this.$apollo
        .query({
          query: GET_REPORT_TIME_WINDOW,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var data = res.data;

          if (self.totalRows === 0) {
            self.reportTimeWindow = [];
            self.isLoading = false;
            return [];
          }
          self.isEmpty = false;
          var results = self.initResult(
            data.reportTimeWindow.reportTimeWindow.data
          );
          self.reportTimeWindow = data.reportTimeWindow.reportTimeWindow.data;
          self.isLoading = false;
          return results;
        });

      return getData;
    },

    openTable(periode, filter, filterGeofence, fields) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.refreshData(periode, filter, filterGeofence, fields);
          this.openSection = false;
        }, 500);
      });
    },

    downloadToExcel(periode, filterVehicle, filterGeofence, fields) {
      fields = fields.filter(
        (field) => field.key !== "vehicle" && field.key !== "geofence"
      );
      var filters = {};
      if (filterVehicle !== undefined) {
        filters = {
          vehicleId: filterVehicle.vehicleId,
        };
      }

      var filterGeofences = {};
      if (filterGeofence !== undefined) {
        filterGeofences = {
          geofenceId: filterGeofence.geofenceId,
        };
      }

      var filterVar = {
        startDate: moment(periode[0] + " 00:00:00.000").toISOString(),
        endDate: moment(periode[1] + " 23:59:59.000").toISOString(),
        column: fields.map((item) => item.header),
        subtitle: "",
        ...filters,
        ...filterGeofences,
      };

      var downloadProgress = {
        name:
          "Jendela Waktu " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".xlsx",
        periode:
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt: moment().format("DD MMM YYYY HH:mm:ss"),
        percentage: 0,
        type: "excel",
      };
      this.$store.commit("report/saveProgress", downloadProgress);

      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if (percentage < 75) {
          percentage += 25;
        } else if (percentage == 75) {
          percentage = 90;
        } else if (percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: percentage,
        });
      }, 500);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_EXCEL_REPORT_TIME_WINDOW,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var isSuccessful = res.data.excelReportTimeWindow.isSuccessful;
          if (isSuccessful) {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 100,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          } else {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 90,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }
        });
    },

    downloadToPdf(periode, filterVehicle, filterGeofence, fields) {
      fields = fields.filter(
        (field) => field.key !== "vehicle" && field.key !== "geofence"
      );
      var filters = {};
      if (filterVehicle !== undefined) {
        filters = {
          vehicleId: filterVehicle.vehicleId,
        };
      }

      var filterGeofences = {};
      if (filterGeofence !== undefined) {
        filterGeofences = {
          geofenceId: filterGeofence.geofenceId,
        };
      }
      var filterVar = {
        startDate: moment(periode[0] + " 00:00:00.000").toISOString(),
        endDate: moment(periode[1] + " 23:59:59.000").toISOString(),
        column: fields.map((item) => item.header),
        subtitle: "",
        ...filters,
        ...filterGeofences,
      };

      var downloadProgress = {
        name:
          "Jendela Waktu " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".pdf",
        periode:
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt: moment().format("DD MMM YYYY HH:mm:ss"),
        percentage: 0,
        type: "pdf",
      };
      this.$store.commit("report/saveProgress", downloadProgress);

      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if (percentage < 75) {
          percentage += 25;
        } else if (percentage == 75) {
          percentage = 90;
        } else if (percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: percentage,
        });
      }, 500);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_PDF_REPORT_TIME_WINDOW,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var isSuccessful = res.data.pdfReportTimeWindow.isSuccessful;
          if (isSuccessful) {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 100,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          } else {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 90,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }
        });
    },
  },
};
</script>
